// extracted by mini-css-extract-plugin
export default {"products":"lw-z","card":"mw-z","oosMessaging":"nw-z"};